import PageProvider, {
    PageContextProps
} from '@tb-core/components/context/webpage';
import WebpageLayout from '@tb-core/components/layout/webpage';
import DocumentHead from '@tb-core/components/regions/document-head';
import TopBody from '@tb-core/components/regions/top-body';
import BasicFooter from '@tb-core/components/styled/basic-footer';
import VisitorPrioritizationMain from '@tb/components/container/regions/visitor-prioritization-main';

import pageData from '@tb-core/data/visitor-prioritization-static.webpage.json';

import '@tb-core/styles/base.scss';

export const getStaticProps = () => ({ props: pageData });

// This is the static page that we will be using to generate the final Visitor Prioritization page
// Ref: https://tacobeta.atlassian.net/wiki/spaces/ECOM/pages/2901344304/Generate+Static+Visitor+Prioritization+Page
const VisitorPrioritizationStaticPage = (props: PageContextProps) => (
    <PageProvider {...props}>
        <WebpageLayout
            regions={{
                footer: <BasicFooter />,
                head: <DocumentHead />,
                main: <VisitorPrioritizationMain />,
                topBody: <TopBody />
            }}
        />
    </PageProvider>
);

export default VisitorPrioritizationStaticPage;
